<template>
  <v-container fluid>
    <v-row class="RouteMap" style="height: 80vh;">
      <v-col :cols="6">
        <Map />
      </v-col>
      <v-col :cols="6" xs12>
        <Chart />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Map from "../components/Map.vue";
import Chart from "../components/Chart.vue";

export default {
  name: "map",
  components: {
    Map,
    Chart
  }
};
</script>
